import { apiClient } from "../api/ApiClient";
import type { KeyValue } from "../models/KeyValue";
import type { PagedResult } from "../models/PagedResult";
import type { Tenant } from "../models/Tenant";
import { BuildFormData } from "../utils/Util";
import { CreateCrudService } from "./CrudServiceFactory";

export function TenantService() {
  const crud = CreateCrudService<Tenant, KeyValue>({
    Route: "tenant",
    EntityName: "Tenant",
    PartialFields: ["BusinessName", "Code"],
    LoadingMessage: "Loading tenants...",
    SavingMessage: "Saving tenant...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.BusinessName ?? ""),
    }),
  });

  const ResolveByUrl = async (
    tenantUrl: string,
  ): Promise<PagedResult<Tenant>> => {
    if (tenantUrl == "localhost")
      tenantUrl = import.meta.env.VITE_APP_TARGET_TENANT;
    const response = await apiClient.get<PagedResult<Tenant>>(
      `/Tenant/GetByUrl/${encodeURIComponent(tenantUrl)}`,
      { showBusyIndicator: false, showError: false },
    );
    return response.data;
  };

  const SaveTenant = async (request: Tenant): Promise<Tenant> => {
    const formData = BuildFormData(request, {
      IncludeNullValues: false,
      MaximumFieldCount: 1000,
    });
    const response = await apiClient.post<Tenant | Tenant[]>(
      "/Tenant/SaveTenant",
      formData,
      {
        busyMessage: "Saving tenant...",
      },
    );
    const tenant = Array.isArray(response.data)
      ? response.data[0]
      : response.data;
    if (!tenant?.Code)
      throw new Error(
        "Tenant save returned no tenant code. Please retry tenant resolution.",
      );
    return tenant;
  };

  return { ...crud, ResolveByUrl, SaveTenant };
}
